import { FeatureName, useIsFeatureEnabled } from '@gripp/shared-logic';
import { StyleSheet, View } from 'react-native';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { Asset as AssetOld } from './asset-old';
import { Assets as AssetsOld } from './assets-old';
import { AssetsShell } from './assetsShell';

export const Assets = () => {
  const isCropCircleEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );
  const { assetId } = useParams();
  const location = useLocation();

  if (isCropCircleEnabled) {
    return <AssetsShell />;
  }

  // /assets/filters and /assets/new require the shell's Outlet to render.
  // Legacy UI uses inline modals and never navigates here, but direct
  // entry or stale bookmarks would otherwise land on the list with a
  // mismatched URL — send them to /assets.
  const pathname = location.pathname.replace(/\/$/, '');
  if (pathname === '/assets/filters' || pathname === '/assets/new') {
    return <Navigate to="/assets" replace />;
  }

  if (assetId) {
    return (
      <View style={styles.container}>
        <AssetOld />
      </View>
    );
  }

  return <AssetsOld />;
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
  },
});